import axios from "axios";
import { config } from "../config";

export const uploadFiles = async (
  files,
  originalFiles,
  uploadForm,
  HTTP_REFERER,
  HTTP_USER_AGENT,
  $_COOKIE
) => {
  const data = {
    name: uploadForm.name,
    email: uploadForm.email,
    phone: uploadForm.phone,
    type: "design",
    files: files,
    originalFiles: originalFiles,
    HTTP_REFERER,
    HTTP_USER_AGENT,
    $_COOKIE,
  };

  const response = await axios.post(
    `${config.BASE_API_URL}/api/v1/clients/process-upload-analysis`,
    data
  );

  return response.data;
};

export const uploadFigmaUrl = async (figmaUrl, uploadForm) => {
  const response = await axios.post(
    `${config.BASE_API_URL}/api/v1/clients/figma-analysis`,
    {
      name: uploadForm.name,
      email: uploadForm.email,
      url: figmaUrl,
    }
  );
  return response.data;
};

export const handleUploadError = (error) => {
  console.error(error);
  let errors = [];

  if (error.response?.data) {
    if (Array.isArray(error.response.data.messages)) {
      errors = error.response.data.messages.map((msg) => msg.detail || msg);
    } else {
      errors = Object.values(error.response.data);
    }
  } else {
    errors.push(error.message || "Unknown error");
  }

  return errors;
};
